// ✅ App.js (React 19 metadata, Helmet removed)

import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import "./App.css";
import { AnimatePresence } from "framer-motion";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer"; // ✅ Footer import
import Loader from "./components/Loader"; // ✅ Loader added
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import Rules from "./pages/Rules";
import Winners from "./pages/Winners";
import Partners from "./pages/Partners";
import ShortlistedTeams from "./pages/ShortlistedTeams"; // ✅ New page import
import Gallery from "./pages/Gallery";

import AIWrapper from "./pages/AIWrapper";

// Optional Pages
// import NotFound from "./pages/NotFound";

// ✅ This component handles routing + loading logic
function AnimatedRoutes({ setLoading }) {
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 800); // duration of loader
    return () => clearTimeout(timeout);
  }, [location.pathname, setLoading]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/winners" element={<Winners />} />
        <Route path="/partners" element={<Partners />} />
        <Route path="/shortlistedteams" element={<ShortlistedTeams />} />
        <Route path="/gallery" element={<Gallery />} />
        {/* ✅ New route */}
        <Route path="/aiwrapper" element={<AIWrapper />} />
        {/* Optional routes */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </AnimatePresence>
  );
}

// ✅ Custom layout component to conditionally show Navbar/Footer
function LayoutWrapper({ children }) {
  const location = useLocation();
  const isAIPage = location.pathname.toLowerCase() === "/aiwrapper"; // ✅ fixed

  return (
    <>
      {!isAIPage && <Navbar />}
      <div
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        <div style={{ flex: 1 }}>{children}</div>
        {!isAIPage && <Footer />}
      </div>
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(false);
  const location = useLocation(); // ✅ Track current route

  const pageTitle =
    location.pathname.toLowerCase() === "/aiwrapper"
      ? "AIWrapper Competition"
      : "CodePK Competition";

  return (
    <>
      {/* ✅ Dynamic Title Handling with React 19 native metadata */}
      <title>{pageTitle}</title>
      <ScrollToTop />
      {loading && <Loader />} {/* ✅ Loader shows only during route change */}
      <LayoutWrapper>
        <AnimatedRoutes setLoading={setLoading} />
      </LayoutWrapper>
    </>
  );
}

export default App;
